module.exports = __webpack_public_path__ + "static/media/HRECOS_background_extend_1.2996ff0e.png";